/** ==================================================================
 * Mixin usado na modal de confirmação das tarifas absoluta e flutante
 ===================================================================== */
import { formatDate } from '@/helpers/date'

export default {
  methods: {
    /**
     * Formata array de objetos em string
     * @param {Array} array array que vai ser manipulado
     *
     * @returns {String} valores separados por vírgula
     */
    formatArrayToString(array) {
      const result = []
      array.forEach((item) => {
        result.push(item)
      })

      return result.join(', ')
    },
    /**
     * Formata uma data de acordo com a string passada
     * @param {Date} date Date obj da data a ser formatada
     * @param {String} formatStr String com o formato final da data
     * @returns {String}
     */
    formatDate: formatDate,
    /**
     * Retorna os nomes das acomodações selecionadas
     * @param {Object} restriciton - Restrição verificada
     *
     * @returns {String} String com os nomes separados por vírgula
     */
    getSelectedRoomNames(restriction) {
      return this.formatArrayToString(
        this.rooms
          .filter((room) =>
            restriction.quartos.includes(room.codigo || room.codigoQuarto)
          )
          .map((room) => room.nome || room.quarto)
      )
    }
  }
}
